@if (formField(); as field) {
    <app-date-picker [(value)]="value" [required]="field.required ? 'true' : 'false'" [label]="field.label || ''" />
}
